import { KeyValue } from "@/main/models/common";
import { DamageAreaTypes, DamageAreaActionTypes } from "./damageAreaTypes";

export function getDamageAreas(): DamageAreaActionTypes {
	return {
		type: DamageAreaTypes.GET_DAMAGEAREAS,
	};
}

export function saveDamageAreas(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): DamageAreaActionTypes {
	return {
		type: DamageAreaTypes.SAVE_DAMAGEAREAS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerDamageAreas(): DamageAreaActionTypes {
	return {
		type: DamageAreaTypes.RESET_REDUCER_DAMAGEAREAS,
	};
}
